import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

export const tabsTheme = defineMultiStyleConfig({
    defaultProps: {
        variant: 'internal',
    },
    variants: {
        internal: definePartsStyle({
            tab: {
                height: '32px',
                marginTop: '4px',
                borderRadius: '4px 4px 0px 0px',
                border: '1px solid rgb(0, 0, 0)',
                borderBottom: 'none',
                padding: '4px 0',
                fontSize: '13px',
                fontWeight: 'bold',
                color: 'white',
                cursor: 'pointer',
                _selected: {
                    borderRadius: '4px 4px 0px 0px',
                    border: '1px solid rgb(0, 0, 0)',
                    background: 'rgb(0, 0, 0)',
                    borderBottom: 'none',
                },
                _focus: {
                    outline: 'none',
                    borderBottom: 'none',
                },
                _hover: {
                    outline: 'none',
                    borderBottom: 'none',
                },
            },
            tabpanel: {},
        }),
    },
});
